const initialState = {
  name: null,
  email: null,
  role: null,
  personId: '',
  isAdmin: false,
  customer: null,
};

const profile = (state = initialState, action) => {
  switch (action.type) {
    case 'LOGOUT_WITH_JWT':
      return {
        ...initialState,
      };
    case 'SET_PROFILE':
      return {
        ...state,
        name: action.data.name || state.name,
        email: action.data.email || state.email,
        role: action.data.role || state.role,
        personId: action.data.personId || state.personId,
        isAdmin: action.data.isAdmin || state.isAdmin,
      };
    case 'SET_CUSTOMER_PROFILE':
      return {
        ...state,
        customer: action.data,
      };
    default:
      return state;
  }
};

export default profile;
